import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle="Страница не найдена. Возможно, она была удалена или вы перешли по неверной ссылке."
      extra={
        <Button
          type="primary"
          icon={<HomeOutlined />}
          onClick={() => navigate('/')}
        >
          На главную
        </Button>
      }
    />
  );
};

export default NotFoundPage;
